import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Heading,
  SectionHeader,
  Paragraph,
  IconSVG,
} from 'components';

const HowWeBuild = () => (
  <Section color={'gray-light'}>
    <SectionHeader
      size={'big'}
      lineColor={'red'}
      headingType={2}
      color={'black'}
      description={
        'We form our teams around three principles: people who have worked together in the past, people who have all the skills required to complete the job, and people with a mixture of seniority.<br /> <br />Exploring why:'
      }
      descriptionColor={'black'}
    >
      How we build
      <br /> our teams
    </SectionHeader>
    <Row className={'no-gap anim-fade-in-bottom development-teams__hwb-list'}>
      <Col sm={12} md={4} className={'development-teams__hwb-item'}>
        <IconSVG name={'gauge'} size={'large'} color={'black'} />
        <Heading color={'black'} size={'medium'} type={3}>
          People who have worked together in the past:
        </Heading>
        <Paragraph color={'black'} additionalClass={'text--light'}>
          We know how time and money are important to you and that is why we
          put great care into quickly reaching the high performance stage of
          team development. When forming a team for your product, we will look
          for at least two members who have worked together in the past so they
          can help the team skip the forming and storming stages and deliver
          value for your business quicker.
        </Paragraph>
      </Col>
      <Col sm={12} md={4} className={'development-teams__hwb-item'}>
        <IconSVG name={'rocket'} size={'large'} color={'black'} />
        <Heading color={'black'} size={'medium'} type={3}>
          Skilled, self-organizing people:
        </Heading>
        <Paragraph color={'black'} additionalClass={'text--light'}>
          Across the years we’ve learnt that skilled, self-organizing teams are
          the most efficient product development teams. Our teams are not
          groups of individuals who want to complete their tasks but units with
          complementary soft and hard skills that can deliver what is needed to
          reach your business goals.
        </Paragraph>
      </Col>
      <Col sm={12} md={4} className={'development-teams__hwb-item'}>
        <IconSVG name={'change'} size={'large'} color={'black'} />
        <Heading size={'medium'} color={'black'} type={3}>
          People with a mixture of seniority:
        </Heading>
        <Paragraph color={'black'} additionalClass={'text--light'}>
          Having delivered over 250 digital products over 14 years, we know
          that a stellar product needs a team that can innovate, think fresh
          and at the same time provide stable development and quality. Forming
          a team with a balance between experienced team members and juniors
          allows us to release cutting-edge, scalable products that fulfil
          users’ needs.
        </Paragraph>
      </Col>
    </Row>
  </Section>
);

export default HowWeBuild;
